import type { IconProps } from "../types";

export const TriangleAlert = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M12 3 22 21 2 21 Z" />
    <path d="M12 9v4" />
    <rect
      x="11"
      y="16"
      width="2"
      height="2"
      fill="currentColor"
      stroke="none"
    />
  </svg>
);
